import React from 'react'

export default function CheckBox(props: any) {
	const { checked, onPress, title, style } = props
	return (
		<div style={{ padding: '5px 0px', ...style }}>
			<input
				style={{ marginRight: '1em' }}
				onClick={() => {
					onPress()
				}}
				checked={checked}
				type='checkbox' />
			<label>{title}</label>
		</div>
	)
}
